import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'
import { Header } from '../../components/Header';
import { NetworkRunTable } from './NetworkRunTable';
import { useState } from 'react';

const NetworkRuns = () => {
    const { push } = useHistory();

    const [networkRunID, setNetworkRunID] = useState();

    return (
        <div>
            <Header
                pageTitle="Network Runs"
            />
            <div style={{ height: '750px' }}>
                <NetworkRunTable networkRunID={setNetworkRunID} />
            </div>
        </div>
    )
}

export default NetworkRuns;